import { ITooltipProps } from 'core-components/library/tooltip'

import { IExpectedExitQuarters } from '../../../../lib'

import styles from './getExpectedExitHint.module.scss'

/** `Q1, Q2` — the quarters one half of the expected exit covers, written the way
 *  `getCockpitPeriodLabel` writes a quarter. */
const formatQuarters = (quarters: number[]) => quarters.map((quarter) => `Q${quarter}`).join(', ')

/** The Expected Exit tooltip: which selected quarters the expected exit reads as actuals and which
 *  as plan, on one line — `Q1, Q2, Q3 Actuals + Q4 Plan`. The same for the table's Sales and SOB
 *  headers and the collapsed tile's cell, since it names quarters, not figures. A half no selected
 *  quarter falls into is left out along with its `+`: only closed quarters read `Q1, Q2 Actuals`,
 *  only open ones `Q1, Q2 Plan`. With neither left, there is nothing to show and no info icon. */
export const getExpectedExitHint = (
  quarters: IExpectedExitQuarters
): ITooltipProps['tipContent'] | undefined => {
  const text = [
    { label: 'Actuals', quarters: quarters.actuals },
    { label: 'Plan', quarters: quarters.plan },
  ]
    .filter((half) => half.quarters.length > 0)
    .map((half) => `${formatQuarters(half.quarters)} ${half.label}`)
    .join(' + ')

  if (!text) {
    return undefined
  }

  return () => <span className={styles.hint}>{text}</span>
}
